import React,{ useState, useRef, useEffect } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { formatLocalString, numericRegex } from "../../../utils/validation";
import instance from "../../../services/services";
import { BANK_LIST_URL, DEPOSIT_REFUND_URL, MY_PAGE_DEPOSIT_TOTAL_URL } from "../../../utils/urls";
import PopupLoginError from "../../../components/Popup/LoginError";
import { useLanguage } from "../../../hooks/useLanguage";

function DepositRefund(){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const bankSelectRef = useRef(null);// 은행 선택
  const { myInfo } = useOutletContext(); // 내 정보
  const [bankList, setBankList] = useState([]); // 은행 목록
  const [selectBank, setSelectBank] = useState({
    isOpen:false,
    bankItem: '',
    bankValue: ''
  });
  const [refundAmount, setRefundAmount] = useState(''); // 환불 요청 금액 상태 추가
  const [isPopupLoginError, setIsPopupLoginError] = useState(false); // 팝업
  const [depositTotal, setDepositTotal] = useState(0);
  const [isFullRefund, setIsFullRefund] = useState(false);



  // 은행 드롭다운 열기/닫기 함수 추가
  const handleBankSelectOpen = () => {
    setSelectBank(prev => ({ ...prev, isOpen: !prev.isOpen }));
  };

  // 은행 선택 시 호출되는 함수
  const handleBankSelectItem = (bank) => {
    setSelectBank(prev => ({
      ...prev,
      bankItem: bank.name,
      bankValue: bank.value,
      isOpen: false
    }));
  };

  // 은행 목록 리스트
  useEffect(()=> {
    const fetchBankList = async () => {
      try{
        const response = await instance.post(BANK_LIST_URL);
        const bankData = response.data.data; // 서버에서 가져온 데이터
        // 객체를 배열로 변환
        const banks = Object.entries(bankData).map(([value, name]) => ({
          value,
          name
        }));
        setBankList(banks); // 변환된 배열로 설정
      } catch (error) {
        console.error('은행 목록 가져오기 실패:', error);
      }
    };
    fetchBankList();
  }, []);

  const handleFullRefundChange = (e) => {
    setIsFullRefund(e.target.checked);
    if (e.target.checked) {
      setRefundAmount(depositTotal.toString());
    } else {
      setRefundAmount('');
    }
  };

  const handleRefundAmountChange = (e) => {
    if (isFullRefund) return; // 모두 환불하기가 체크되어 있으면 입력 불가
    
    // 콤마 제거 후 숫자가 아닌 문자 모두 제거
    const value = numericRegex(e.target.value.replace(/,/g, ''));
    
    // 입력된 금액이 총 예치금보다 높은지 확인
    if (value && parseInt(value) > depositTotal) {
      setIsPopupLoginError('환불 요청 금액이 보유 예치금을 초과할 수 없습니다.');
      setRefundAmount(depositTotal.toString()); // 기존 금액 매핑
      return;
    }
    
    setRefundAmount(value);
  };

  const handleRefund = async () => {
    // 입력값 검증
    if (!refundAmount) {
      setIsPopupLoginError(t('refund_amount_txt'));
      return;
    }

    // 환불 요청 금액이 총 예치금보다 높은지 확인
    if (parseInt(refundAmount) > depositTotal) {
      setIsPopupLoginError('환불 요청 금액이 보유 예치금을 초과할 수 없습니다.');
      return;
    }

    if (!selectBank.bankValue) {
      setIsPopupLoginError(t('refund_bank_txt'));
      return; 
    }

    const accountNumber = document.getElementById('account_number').value;
    if (!accountNumber) {
      setIsPopupLoginError(t('refund_account_number_txt'));
      return; 
    }

    try {
      const response = await instance.post(DEPOSIT_REFUND_URL, {
        apply_name: myInfo?.user_name,
        balance: refundAmount, // 입력한 환불 요청 금액
        balance_refund_bank: selectBank.bankValue, // 선택한 은행의 키값
        balance_refund_number: accountNumber // 입력한 계좌번호
      });

      if (response.data.code === 200) {
        setIsPopupLoginError({
          message: t('refund_completed_txt') + '<br/>' + t('refund_completed_txt2'),
          action: 'navigate_login'
        });
      } else {
        setIsPopupLoginError(response.data.message);
      }
    } catch (error) {
      setIsPopupLoginError('환불 신청 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

    // 팝업 확인 버튼 클릭 핸들러 추가
    const handleConfirm = () => {
      if (isPopupLoginError.action === 'navigate_login') {
        navigate('/myPage/deposit'); // 페이지 이동
      }
      setIsPopupLoginError(false); // 팝업 닫기
    };

  // 총 예치금 조회
  useEffect(() => {
    const fetchDepositTotal = async () => {
      const response = await instance.post(MY_PAGE_DEPOSIT_TOTAL_URL);
      setDepositTotal(response.data.data.balance);
    };
    fetchDepositTotal();
  }, []);

  return(
    <div>
      <div className="my_container point_container mt_48">
        <div className="order_title">
          <h3>{t('deposit_info_23')}</h3>
        </div>
        <ul className="default_info_table v2 payment deposit_form refund_form">
          <li className="info_item">
            <div className="label">
              <label htmlFor="use_name">{t('account_holder')}</label>
            </div>

            <div className="form_info">
              <div className="info_detail">
                <div className="default_input">
                  <input
                    type="text"
                    id="use_name"
                    placeholder={t('account_holder')}
                    disabled
                    value={myInfo?.user_name}
                  />
                </div>
              </div>
            </div>
          </li>
          
          <li className="info_item">
            <div className="label">
              <label htmlFor="use_deposit">{t('deposit_info_24')}</label>
            </div>

            <div className="form_info">
              <div className="info_detail deposit_amount">
                <div className="deposit_input">
                  <div className="default_input comb-input">
                    <input
                      id="use_deposit"
                      placeholder="0"
                      type="text"
                      value={refundAmount ? formatLocalString(refundAmount) : ''} // 포맷된 값 표시
                      onChange={handleRefundAmountChange} // 포맷팅 함수 호출
                    />
                    <i className="comb_btn-right">{t('price_txt')}</i>
                  </div>
                  
                  <p className="text_small_b flex-center-4">
                    <span className="g-80">{t('deposit_info_17')}</span>
                    <span>
                      {formatLocalString(depositTotal)} 
                      <i className="quo_count">{t('price_txt')}</i>
                    </span>
                  </p>

                  <div className="default_chk_box">
                    <input
                      type="checkbox"
                      id="full_refund"
                      checked={isFullRefund}
                      onChange={handleFullRefundChange}
                    />
                    <label htmlFor="full_refund">
                      <span>{t('deposit_info_26')}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li className="info_item">
            <div className="label">
              <span>{t('deposit_info_27')}</span>
            </div>

            <div className="form_info">
              <div className="info_detail">
                <div className="default_select border">
                  <div
                    ref={bankSelectRef} 
                    className={`default_select border ${selectBank.isOpen ? 'open' : ''}`}
                  >
                    <button
                      type="button"
                      className={`select_btn ${selectBank.bankValue ? 'active' : ''}`}
                      onClick={handleBankSelectOpen}
                    >
                      <span className="ellipsis_clamp">
                        {selectBank.bankItem ? (
                          <span className="select_store">{selectBank.bankItem}</span>
                        ) : (
                          <span>{t('select_bank')}</span>
                        )}
                      </span>
                    </button>
                    <ul className="select_list">
                      {bankList.map((bank) =>(
                        <li
                          key={bank.value}
                          className={`select_item ellipsis1 ${
                            selectBank.bankValue === bank.value ? 'active' : ''
                          }`}
                          onClick={() => handleBankSelectItem(bank)}
                        >
                          {bank.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li className="info_item">
            <div className="label">
              <label htmlFor="account_number">{t('deposit_info_28')}</label>
            </div>

            <div className="form_info">
              <div className="info_detail">
                <div className="default_input">
                  <input
                    type="number"
                    id="account_number"
                    placeholder={t('enter_without_dash')}
                  />
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div className="bottom_info_box dash_list">
          <div className="alert_box gray flex-2 column">
            <span className="color_black">
              {t('deposit_info_29')}
            </span>
            <span className="color_black">
              {t('deposit_info_30')}
            </span>
          </div>
        </div>

        {/* 환불신청 */}
        <div className="submit_box mt_48 bg">
          <button 
            type="button"
            className="default_btn lg black" 
            onClick={handleRefund}
          >
            {t('refund')}
          </button>
        </div>
      </div>

      <PopupLoginError isPopup={isPopupLoginError} setIsPopup={setIsPopupLoginError} onConfirm={handleConfirm}/>

    </div>
  )
};

export default DepositRefund;